<script>
export default {
  props: {
    type: String,
    selectOrder: Number,
  },

  data() {
    return {
      orderBy: null,
    };
  },

  mounted() {
    this.order = this.selectOrder;
  },

  computed: {
    order: {
      get() {
        return this.orderBy;
      },
      set(newValue, oldValue) {
        if (!!newValue && newValue != oldValue) {
          this.$emit("orderEdit", newValue);
          this.orderBy = newValue;
        }
      },
    },
  },
};
</script>
<template>
  <select v-model="order" class="form-input" name="order_by">
    <!-- <option hidden selected> Ordenar por </option> -->
    <option selected value="1">Más recientes</option>
    <option value="2">Más antiguos</option>
    <option value="3">Mayor precio</option>
    <option value="4">Menor precio</option>
    <option value="5">Aleatorio</option>
  </select>
</template>